import React from "react";
import { ArrowUpRight } from "lucide-react";
import { AREAS, CONTACT } from "../lib/constants";

const AreasPage = () => {
  return (
    <div>
      <section className="ve-container pt-20 md:pt-28 pb-12 ve-noise">
        <span className="ve-eyebrow">Areas We Serve</span>
        <h1 className="ve-display mt-6 text-[2.6rem] sm:text-4xl md:text-6xl lg:text-7xl max-w-5xl">
          Twelve micro-markets.<br />
          <em>One Ahmedabad West.</em>
        </h1>
        <p className="mt-8 max-w-3xl text-base md:text-lg leading-relaxed" style={{ color: "var(--cream-200)" }}>
          We intentionally confine our practice to Ahmedabad's western corridor. Twelve pockets, each with a distinct character, price band and buyer profile — and each one tracked by us closely enough that we can tell you what a flat sold for last month, and why.
        </p>
      </section>
      <div className="ve-rule" />
      <section className="ve-container py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: "var(--hair)" }}>
          {AREAS.map((a, i) => (
            <article
              key={a.name}
              className="p-8 md:p-10 transition-colors"
              style={{ background: "var(--ink-800)" }}
            >
              <div className="ve-number">{String(i + 1).padStart(2, "0")}</div>
              <h3 className="mt-4 text-3xl md:text-[2.2rem]" style={{ fontFamily: "Fraunces, serif", color: "var(--cream-100)", fontWeight: 400 }}>
                {a.name}
              </h3>
              <div className="mt-1 text-xs tracking-[0.2em] uppercase" style={{ color: "var(--gold-500)" }}>
                {a.tag}
              </div>
              <p className="mt-6 text-sm leading-relaxed" style={{ color: "var(--cream-200)" }}>
                {a.body}
              </p>
              <a
                href={`${CONTACT.whatsappLink.split("?")[0]}?text=${encodeURIComponent(`Hello Vachhraj Estate, I'd like to enquire about properties in ${a.name}.`)}`}
                target="_blank"
                rel="noreferrer"
                className="mt-8 inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase"
                style={{ color: "var(--gold-400)" }}
              >
                Enquire About {a.name} <ArrowUpRight size={14} />
              </a>
            </article>
          ))}
        </div>
      </section>
      <section className="border-t" style={{ borderColor: "var(--hair)", background: "var(--ink-900)" }}>
        <div className="ve-container py-20 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <span className="ve-eyebrow">A note on coverage</span>
            <h2 className="ve-display mt-5 text-3xl md:text-5xl">
              If it's in the list,<br />
              <em>we know it well.</em>
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed" style={{ color: "var(--cream-200)" }}>
              If a location isn't above — think Bopal Main, Motera, Vaishnodevi Circle or Chandkheda — we can still help on a best-effort basis. But our deepest price, resale and builder intelligence sits firmly in the twelve listed micro-markets. We'd rather be excellent in twelve places than average in twenty.
            </p>
          </div>
          <div className="lg:col-span-5 flex flex-col justify-end gap-3">
            <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="ve-btn-primary justify-center">
              WhatsApp an Enquiry
            </a>
            <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-ghost justify-center">
              Call {CONTACT.phoneDisplay}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AreasPage;